export default __webpack_public_path__ + "static/media/img2.8c0189fe.png";